import { render } from "./VersionControlPopup.vue?vue&type=template&id=084f1b0a&scoped=true"
import script from "./VersionControlPopup.vue?vue&type=script&lang=js"
export * from "./VersionControlPopup.vue?vue&type=script&lang=js"

import "./VersionControlPopup.vue?vue&type=style&index=0&id=084f1b0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084f1b0a"]])

export default __exports__